var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 475.8 475.8",
    viewBox: "0 0 475.8 475.8",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)",
    fill: "#eb5569",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.5,781.56c0-0.2-0.1-0.3-0.1-0.5c-4-15.1-17.2-25.7-32.1-25.7h-0.8c-0.2,0-0.3,0-0.5,0c-8.4,0.5-15.3-5-17-13.4 c-1.6-8.1,2.7-16.3,10.3-19.5c7.6-3.2,16.8-0.4,20.9,6.3c2.2,3.5,6.8,4.6,10.3,2.4c3.5-2.2,4.6-6.8,2.4-10.3 c-4.3-7-11.1-11.7-18.7-13.8v-20.3c0-4.1-3.4-7.5-7.5-7.5c-4.1,0-7.5,3.4-7.5,7.5v19.9c-2,0.4-4,1-5.9,1.9 c-14.1,6-22.2,21.3-19.2,36.3c3.1,15.6,16.7,26.3,32.4,25.4h0.6c8,0,15.2,5.9,17.5,14.4c1.5,8.1-3,16-11,19.2 c-0.1,0-0.1,0-0.2,0.1c-7.5,3.2-15.9,0.5-20.2-6.3c-2.2-3.5-6.8-4.6-10.3-2.5c-3.5,2.2-4.6,6.8-2.5,10.3 c4.4,7.1,11.1,11.9,18.7,13.9v20.2c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5v-20.1c1.7-0.4,3.4-1,5.1-1.7 C265.3,811.96,273.6,796.96,270.5,781.56L270.5,781.56z",
    fill: "#eb5569",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,540.36c-59.5,0-115.5,23.2-157.6,65.3c-42.1,42.1-65.3,98.1-65.3,157.6c0,0.6,0,1.2,0,1.9c0,0.2,0,0.3,0,0.5v28.7 c0,78.9,42.6,152.4,111,191.7c34,19.7,72.5,30.1,111.5,30.1s77.5-10.4,111.4-30c33.9-19.3,62.1-47.2,81.5-80.9 c19.4-33.5,29.6-71.9,29.6-110.9v-28.7c0-0.2,0-0.3,0-0.5c0-0.6,0-1.2,0-1.9C460.4,640.36,360.8,540.36,238.3,540.36z  M341.8,973.06L341.8,973.06c-32.1,18.6-68,27.9-103.9,27.9c-35.9,0-71.9-9.3-104-27.9c-36.9-21.2-65.7-53-83.5-90.3 c39.6,61.7,109,102.6,187.8,102.6c78.6,0,147.8-41,187.3-102.8C407.8,920.16,378.9,951.96,341.8,973.06z M238.3,970.46 c-114.6,0-207.9-92.9-207.9-207.1c0-114.7,93.3-207.9,207.9-207.9v0c114.2,0,207.1,93.3,207.1,207.9 C445.4,877.56,352.5,970.46,238.3,970.46z",
    fill: "#eb5569",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,592.76c-94,0-170.5,76.5-170.5,170.5s76.5,170.5,170.5,170.5s170.5-76.5,170.5-170.5S331.9,592.76,237.9,592.76z  M237.9,918.76c-85.7,0-155.5-69.8-155.5-155.5s69.8-155.5,155.5-155.5s155.5,69.8,155.5,155.5S323.6,918.76,237.9,918.76z",
    fill: "#eb5569",
    className: "color000 svgShape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.67498369ec8bfbf79fed1defc26d539c.svg";
export { ForwardRef as ReactComponent };